import React, { useState, useContext, useEffect } from "react";
import styled, { css } from "styled-components";

import {
  InputCopy,
  FormGroup,
  Select,
  Tooltip,
  StatusDot,
  Checkbox,
  Subheader,
  Button,
  Head,
  Card,
  Input,
  RadioGroup,
  Icon,
  Tag,
  FormFooter,
  Notification
} from "xsolla-uikit";


import PAtabs from "./PAtabs";

import merge from "deepmerge";
import { ContextConsumer } from "../App";
import { IntlProvider } from "react-intl";
import PAContentBlock from "./PAContentBlock";
import { Link } from "react-router-dom";





import CardNew, {CardItem,  CardTodo, CardSite, CardFlatten } from "./PAcardNew";

import { PAchart1, PAchartMap } from "./PAcharts";
import { PAchart1fake, PAchart2 } from "./PAchart2";

export default function PAlauncher() {
  const launcher = [
    {
      product: 'launcher',
      sku: 'my_project',
      name: "Cyberpunk 2088",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      img: "https://cdn.xsolla.net/xsolla-com-v6/file-1080-4Syu6kc1.jpeg",
      //img: ()=>{return <img style={{width: '200px'}} src="https://cdn.xsolla.net/xsolla-com-v6/file-1080-4Syu6kc1.jpeg"/>},
      button: ()=>{return <Link to="/launcher/my_project">
        <Button
          appearance="outline"
        >
          Edit settings
        </Button>
      </Link>},
      status: "active",
      used: [
        {
          product: 'game_keys',
          name: "My Game: Ultimate Edition",
          action: "/game_keys/my_project",
          status: 'active',
        },

      ],
      todo: [
        {
          title: "Complete setting up your landing page",
          value: 0.5
        },

      ],
    },
    {
      product: 'launcher',
      sku: 'my_project3',
      name: "Cyberpunk 2019 Standard Edition",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      img: "https://cdn.xsolla.net/xsolla-com-v6/file-1080-4Syu6kc1.jpeg",
      status: "draft",
      used: [
        {
          name: "My Game: Ultimate Edition",
          action: "/game_keys/my_project/"
        }
      ],
      todo: [
      {
        title: "Add a callback url",
        value: 0.5
      },
      ],

    },
    {
      product: 'launcher',
      sku: 'my_project_another',
      name: "Cyberpunk 2019 Collectors Edition",
      id: "ce084f8d-89bf-11e8-ad67-d89d67155224",
      img: "https://cdn.xsolla.net/xsolla-com-v6/file-1080-4Syu6kc1.jpeg",
      status: "draft",
      used: [],
      todo: [
        {
          title: "Add a callback url",
          value: 0.5
        },
        {
          title: "Enable social networks",
          value: 0
        },
        ],
    }
  ];

  const [state, setState] = useState({
    tab: "all"
  });

  return (

      <div className="xsui-width">


        <FormGroup>
          <div className="xsui-breadcrumbs_entry">
            <div className="xsui-breadcrumbs_item">
              <Link className="xsui-breadcrumbs_label" to="/game_keys">
                <div className="xsui-typography--display">Xsolla launcher</div>
              </Link>
              <div className="xsui-breadcrumbs_chevron">
                <i
                  className="xsui-icon xsui-icon-chevron"
                  style={{
                    fontSize: 24,
                    color: "inherit"
                  }}
                />
              </div>
            </div>
          </div>
        </FormGroup>



        <div className="xsui-width">
          {state.tab === "stat" && (
            <FormGroup indentation="lg">
              <CardNew  indentation="lg" wave={false}>
                <PAchart1fake />
              </CardNew>
            </FormGroup>
          )}

          {state.tab === "all" && (
            <FormGroup indentation="lg">
              <CSScards>
                {launcher.map((oneKey, ind) => {
                  return (
                    // <FormGroup indentation="lg" key={`login_${ind}`}>
                      <CardItem size="sm" {...oneKey} />
                    // </FormGroup>
                  );
                })}
              </CSScards>
            </FormGroup>
          )}
        </div>
      </div>

  );
}


const CSScards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(360px, 1fr));
  grid-column-gap: 24px;
`;